module.exports = __webpack_public_path__ + "files/aab9fce458cd4a2a8c53a42003816349.svg";